<section class="crosswalk">
  <h1>RPL to CCSA mappings</h1>

  <p *ngIf="error" role="alert" class="error">{{ error }}</p>

  <div class="flex justify-between items-center m2 toolbar">
    <form class="flex items-center" (ngSubmit)="load(true)">
      <mat-form-field>
        <mat-label>Search RPL, ICD or CCSA code</mat-label>
        <input matInput name="search" [(ngModel)]="search">
      </mat-form-field>
      <button class="m-l-10" mat-raised-button type="submit" [disabled]="loading">Search</button>
    </form>

    <button *ngIf="canEdit" mat-raised-button color="accent" type="button" (click)="openDialog()">
      <mat-icon>add</mat-icon>
      Add Mapping
    </button>
  </div>

  <section class="mat-elevation-z8 table-container" [attr.aria-busy]="loading">
    <table mat-table [dataSource]="dataSource">
      <ng-container [matColumnDef]="tableColumns.Rpl">
        <th *matHeaderCellDef mat-header-cell>RPL</th>
        <td *matCellDef="let row" mat-cell><strong>{{ row.rplCode }}</strong><br>{{ row.rplDescription }}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Diagnosis">
        <th *matHeaderCellDef mat-header-cell>Primary ICD</th>
        <td *matCellDef="let row" mat-cell><strong>{{ row.primaryDiagnosisCode }}</strong><br>{{ row.diagnosisDescription }}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Ccsa">
        <th *matHeaderCellDef mat-header-cell>CCSA</th>
        <td *matCellDef="let row" mat-cell><strong>{{ row.ccsaCode || 'No equivalent' }}</strong><br>{{ row.ccsaDescription }}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Age">
        <th *matHeaderCellDef mat-header-cell>Age</th>
        <td *matCellDef="let row" mat-cell>{{ ageDescription(row) }}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Status">
        <th *matHeaderCellDef mat-header-cell>Status</th>
        <td *matCellDef="let row" mat-cell><strong>{{ statusDescription(row) }}</strong><br>{{ row.notes }}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Updated">
        <th *matHeaderCellDef mat-header-cell>Last Updated</th>
        <td *matCellDef="let row" mat-cell>{{ row.updated | date:'yyyy-MM-dd HH:mm' }}<br>{{ row.updatedBy }}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Actions">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let row" mat-cell>
          <button mat-icon-button type="button" (click)="openDialog(row)"
                  [attr.aria-label]="'Edit mapping for RPL ' + row.rplCode">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns: displayedColumns" class="row" mat-row></tr>
      <tr *matNoDataRow class="mat-row">
        <td class="mat-cell no-data" [attr.colspan]="displayedColumns.length">
          {{ loading ? 'Loading mappings…' : 'No mappings found.' }}
        </td>
      </tr>
    </table>

    <mat-paginator [length]="total" [pageIndex]="pageIndex" [pageSize]="pageSize"
                   [pageSizeOptions]="[25, 50, 100]" [disabled]="loading"
                   (page)="page($event)" aria-label="Mapping pages">
    </mat-paginator>
  </section>
</section>
